import Text from "./Text";
import { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import TextContainer from "./TextContainer";
import { Col, Row, useIsMobile } from "./Flexbox";
import { MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import ConfirmationWindow from "./ConfirmationWindow";
const EditUser = ({theme, activeUser, onClose, roles, roleNameMap, claims, updateUser, deleteUser, onSuccess, changeReq, resolveRequest, isDark}) => {
    const isMobile = useIsMobile();
    const [name, setName] = useState("");
    const [role, setRole] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [error, setError] = useState(null);
    const [formMessage, setFormMessage] = useState({text: null, color: null});
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const departments = Object.keys(roles);

    const openPopup = () => {
        setIsPopupOpen(true);
    }

    const formatMessage = (text, color) => {
        setFormMessage({text: text, color: color || theme.Red})
    }

    const groups = claims?.groups || [];

    useEffect(() => {   //Set default values according to the selected user
        if(activeUser) {
            setName(activeUser.name || "");
            setRole(activeUser.roleKeys || []);
            // console.log(`Data: ${activeUser.username} ${name} ${role}`)
        } else {
            setName("");
            setRole([]);
        }
    }, [activeUser]);

    const roleSelection = (selectedKeys) => {
        const roleNames = selectedKeys.map(key => roleNameMap[key] || key);
        return roleNames.join(', ');
    }

    const handleUpdate = async (e) => {
        e.preventDefault();
        formatMessage(null);
        setError(null);

        if (!name || role.length === 0) {
            formatMessage("Todos los campos son obligatorios")
            return;
        }

        //Compare arrays to check if the content is the same, in which case an update is not needed
        const rolesChanged = JSON.stringify([...role].sort()) !== JSON.stringify([...activeUser.roleKeys].sort());

        if (name === activeUser.name && !rolesChanged && !activeUser.isFromRequest) {
            formatMessage("No se realizaron cambios, no hay datos para actualizar.")
            setIsUpdating(false);
            return;
        }

        setIsUpdating(true);
        let result;

        if (!claims?.actions?.includes('updateuser') && !claims.groups?.includes('superadmin')) {
            const userData = {
                username: activeUser.name,
                mail: activeUser.email,
                currentRole: activeUser.department,
                newRole: role.join(', ')
            }
            
            result = await changeReq(userData);
            handleResponse(result, "Solicitud enviada para su revisión");
            return;
        }

        const userData = {
            Username: activeUser.username,
            Name: name,
            NewDepartment: role.join(', ')
        };

        result = await updateUser(userData);

        if (result.success) {
            if (activeUser.isFromRequest) {
                await resolveRequest({
                    mail: activeUser.email, 
                    request_id: activeUser.request_id,
                    action: 'ACCEPT', 
                    admin_mail: claims.email
                });
            }
            handleResponse(result, "Usuario actualizado con éxito");
        } else {
            setError(result.message);
            setIsUpdating(false);
        }
    }

    const handleResponse = (result, successText) => {
        if (result.success) {
            formatMessage(successText, theme.Verde);
            setTimeout(() => {
                onSuccess();
            }, 3000);
        } else {
            setError(result.message);
        }
        setIsUpdating(false);
    }

    const handleDeletion = async () => {
        const result = await deleteUser(activeUser.email)
        if (result.success) {
            formatMessage("Usuario eliminado con éxito", theme.Verde);
            setTimeout(() => {
                onSuccess();
            }, 3000);
        } else {
            setError(result.message);
        }
    }

    return (
        <form onSubmit={handleUpdate}>
            <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
                <Col style={{width:'100%', height: '100%', maxWidth: '600px', maxHeight: '430px', flex:'none', alignItems:'flex-start', paddingLeft: isMobile ? 16 : 32, paddingRight: isMobile ? 16 : 32, paddingTop: 32, paddingBottom: 32, marginTop: 32, backgroundColor: theme.White,  borderRadius: 4, boxShadow: isDark ? '0px 10px 40px rgba(0, 0, 0, 0.8)' : '0px 10px 30px rgba(0, 0, 0, 0.1)', overflowY: 'auto'}}>
                    <Col style={{height: 55, flex:'none', width: '100%', alignItems:'flex-start', justifyContent: 'space-between'}}>
                        <Text color={theme.Black} size={21} weight={"bold"}>Editar usuario</Text>
                        <Text color={theme.Black} size={15} style={{fontStyle: "italic"}}>{activeUser.email}</Text>
                    </Col>
                    <Col style={{alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', gap: 32, marginTop: 32}}>
                        <Col style={{alignItems: 'start', width: '100%'}}>
                            <Text color={theme.Black} size={15} weight={"medium"}>Nombre</Text>
                            <TextContainer style={{width: '100%', height: 36}} value={name} theme={theme} placeHolder="" onChange={(value) => setName(value)}/>
                        </Col>
                        <Col style={{alignItems: 'start', width: '100%'}}>
                            <Text style={{marginBottom: 5}} color={theme.Black} size={15}  weight={"medium"}>Rol de permisos</Text>
                            <Dropdown theme={theme}  multiple={true} value={role} onChange={(value) => setRole(value)} style={{width: '100%', height: 36}} renderValue={roleSelection}>
                                {departments.map((role) => (
                                    <MenuItem key={role} value={roles[role]}>{role}</MenuItem>
                                ))}
                            </Dropdown>
                        </Col>
                        {!claims.actions?.includes("updateuser") && (
                            <Col style={{alignItems: 'start', width: '100%'}}>
                                <Text color={theme.Black} size={15} weight={"medium"}>Cualquier cambio de rol quedara pendiente para aprobación, en caso de urgencia, {' '} <a href="mailto:link@laserprint.com.mx?subject=Cambio de rol urgente" style={{color: theme.Magenta}}>contacta directamente al administrador.</a></Text>
                            </Col>
                        )}
                    </Col>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, position: 'relative', marginTop: '10px'}}>
                        {formMessage && <Text color={formMessage.color} size={12} style={{position: 'absolute' }}>{formMessage.text}</Text>}
                        {error  && <Text color="red" size={12} style={{position: 'absolute' }}>{error}</Text>}
                    </div>
                    <Row style={{width: '100%', justifyContent: 'end', paddingTop: 64, gap: 16}}>
                        {(claims.actions?.includes("deleteuser") || groups?.includes("superadmin") || groups?.includes("admin")) && (
                            <Row style={{flex: 1, justifyContent: 'start'}}>
                                <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={openPopup} color={theme.Red} size={15}>Dar de baja</Text>
                            </Row>
                        )}
                        <Row style={{width: '100%', justifyContent: 'end', gap: 16}}>
                            <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Lao} size={15} onClick={onClose}>Cancelar</Text>
                            <Button disableElevation type="submit" disabled={isUpdating} variant="contained" sx={{height: 20, backgroundColor: 'transparent', color: isUpdating ? theme.Ey : theme.Magenta, fontSize: 15, textTransform: 'none', whiteSpace: 'nowrap'}}>Guardar cambios</Button>
                        </Row>
                    </Row>
                </Col>
                {isPopupOpen && <ConfirmationWindow theme={theme} message={"Confirma que desea eliminar este usuario?"} action={handleDeletion} btnText={"Eliminar usuario"} onClose={onClose}/>}
            </div>
        </form>
    )
}

export default EditUser;